var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { background: "rgb(172,174,171)" } }, [
        _c("div", { staticClass: "container pt-5 pb-5 mb-5" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h1", [_vm._v("Twitter Rumour Verifier")]),
              _vm._v(" "),
              _c("form", { staticClass: "form", attrs: { method: "get" } }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "input-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.tweetSearch,
                          expression: "tweetSearch"
                        }
                      ],
                      class: [
                        "form-group",
                        "form-control",
                        { "is-invalid": _vm.tweetSearchError }
                      ],
                      attrs: {
                        list: "tweetSearchHistoryList",
                        type: "text",
                        name: "tweeturl",
                        placeholder: "Enter or paste the twitter URL to verify."
                      },
                      domProps: { value: _vm.tweetSearch },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.tweetSearch = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group-append" }, [
                      _c("input", {
                        staticClass: "btn btn-primary",
                        attrs: { type: "submit", value: "Verify!" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.findSourceTweet($event)
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.tweetSearchError
                    ? _c("div", { staticClass: "form-error" }, [
                        _vm._v(_vm._s(_vm.tweetSearchError))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "datalist",
                    { attrs: { id: "tweetSearchHistoryList" } },
                    _vm._l(_vm.tweetSearchHistory, function(tweetId) {
                      return _c("option", [_vm._v(_vm._s(tweetId))])
                    }),
                    0
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.errorMessage
          ? _c(
              "div",
              {
                staticClass: "fixed-top text-center",
                staticStyle: {
                  "margin-top": "3em",
                  "margin-left": "auto",
                  "margin-right": "auto",
                  width: "80%"
                }
              },
              [
                _c("div", { staticClass: "alert alert-warning" }, [
                  _vm._v(_vm._s(_vm.errorMessage))
                ])
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("tweet-search-result", {
            attrs: { "tweet-address": _vm.tweetSearchConfirm }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }